/* Система Sysupdate. */
/* Функция sysupdateServer() создает объект oSysupdateServer для обновления данных на сервере. */
/* Функция sysupdateServer(oSysupdateBase, oSysupdateClient) - начало работы по обновлению объектов и сервера. */
/* В качестве параметров принимаются: */
/* oSysupdateBase - базовый объект */
/* oSysupdateClient - объект объекта */
window.sysupdateServer = function(oSysupdateBase, oSysupdateClient)
{
	var oSysupdateServer =
	{
		oSysupdateBase: null, // Базовый объект
		oSysupdateClient: null, // Объект по работе с объектами
		oUpdateHandler: null, // Объект для обновления сервера
		aClients: [], // Список объектов
		aClientSQL: [], // Список объектских sql-файлов
		date: null, // Запоминает дату (название папки) при обновлении системы
		zipname: null, // Имя временно распакованного архива
		oButton: null, // Кнопка старта обновления системы (для её блокировки/разблокировки)
		oUploadData: {},
		ibUploadArray: false,
		ini: function(oSysupdateBase, oSysupdateClient)
		{
			this.oSysupdateBase = oSysupdateBase; // Базовый объект
			this.oSysupdateClient = oSysupdateClient; // Объект клиента
			this.oUpdateHandler = this.getUpdateHandler(null, null); // Внутренний объект сервера, который отвечает за обновления на сервере
			return this;
		},
		uploadNewArray: function(oParent)
		{
			var $this 		= oParent, // Стартовый объект oSysupdate
				oServer 	= this, // Ссылка на самого себя, так как здесь тяжело получить доступ к нужному this.
				oFile 		= $this.oSysupdateBase.oInputParam.oInputFile, // Объект файла
				formdata 	= (window.FormData) ? new FormData() : false; // Переменая для сбора всех $_POST и $_FILES
			oServer.ibUploadArray = false; // В данный момент архив еще не загружен
			if( !oFile.val().length ) // Архив не загружен
			{
				$this.oSysupdateBase.html("Укажите архив для обновления!", "important");
				$this.oSysupdateBase.saveInformation();
				return false;
			}
			if(formdata)
			{
				$this.oSysupdateBase.loading(true);
				formdata.append("file", oFile.prop('files')[0]);
	            formdata.append("ajax", 1);
	            formdata.append("operation", 1);
		        $.ajax({
		        	dataType: "json",
		            url: "/sysupdate",
		            type: "POST",
		            data: formdata,
		            processData: false,
		            contentType: false,
		            success: function (data)
		            {
		            	var ibFlag = false;
		            	oServer.oUploadData = data;
		            	$this.oSysupdateBase.loading(false);
		            	if( data.bResult )
		            	{
		            		$this.oSysupdateBase.append("Архив успешно распакован на сервере для дальнейшей работы.", "default");
		            		$this.oSysupdateBase.append(data.sMessage, "default");
		            		$this.oSysupdateBase.oSaveData = data;
		            		if( data.aResult.server )
		            		{
		            			if( data.aResult.server.clients )
		            			{
		            				$this.oSysupdateBase.append("В настройках указано обновление объектов и сервера.", "success");
		            				oServer.aClients = data.aResult.server.clients;
		            				if( data.aResult.client &&
		            					(data.aResult.client.sql ||
										data.aResult.client.patches ||
										data.aResult.client.files ||
										data.aResult.client.command) )
		            				{
		            					ibFlag = 1; // Сценарий 1
		            					oServer.aClientSQL = data.aResult.client.sql;
		            					$this.oSysupdateClient.bSuccessful = true;
		            					$this.oSysupdateClient.createClientContainer(data.aResult.server.clients);
		            				}
		            				else
		            				{
		            					$this.oSysupdateBase.append("Ошибка: нет инструкций для обновления объектов.", "important");
		            					ibFlag = false;
		            				}
		            			}
		            			else
		            			{
		            				$this.oSysupdateBase.append("В настройках указано обновление только на сервере.", "success");

		            				if( data.aResult.server.sql ||
										data.aResult.server.patches ||
										data.aResult.server.files ||
										data.aResult.server.command )
		            				{
		            					ibFlag = 2; // Сценарий 2
		            				}
		            				else
		            				{
		            					$this.oSysupdateBase.append("Ошибка: нет инструкций для обновления сервера.", "important");
		            					$this.oSysupdateBase.append("Обновление завершено.", "success");
		            					ibFlag = false;
		            				}
		            			}
		            		}
		            		else
		            		{
		            			if( data.aResult.client )
		            			{
		            				$this.oSysupdateBase.append("Неправильно сформирован файл с инструкциями.", "important");
		            				$this.oSysupdateBase.append("Чтобы обновить целевой объект, укажите настройки так же как и для сервера.", "important");
		            				ibFlag = false;
		            			}
		            			else
		            			{
		            				$this.oSysupdateBase.append("Нет инструкций для обновления объектов и сервера.", "important");
		            				ibFlag = false;
		            			}
		            		}
		            	}
		            	else
		            	{
		            		$this.oSysupdateBase.append(data.sMessage, "important");
		            		$this.oSysupdateBase.append("Ошибка при извлечении архива. Дальнейшее обновление объектов невозможно.", "important");
		            		ibFlag = false;
		            	}
		            	oServer.ibUploadArray = ibFlag;
		            	if( !oServer.ibUploadArray ) $this.oSysupdateClient.createClientError();
		            	$this.oSysupdateBase.saveInformation();
		            },
		            error: function (XMLHttpRequest, textStatus, errorThrown)
		            {
		            	// Фатальная ошибка, Завершение работы.
		            	$this.oSysupdateBase.error(XMLHttpRequest, textStatus, errorThrown);
		            	oServer.ibUploadArray = false;
					}
	        	});
	        }
	        else
	        {
	        	$this.oSysupdateBase.errorsHandler(null, 4, 1);
	        	oServer.ibUploadArray = false;
	        }
		},
		updateStart: function(e) // Распаковываем архив на сервере и получаем всех объектов
		{
			var $this 	= e.data.this, // Стартовый объект oSysupdate
				oServer 	= e.data.oServer, // Ссылка на самого себя, так как здесь тяжело получить доступ к нужному this.
				oPrevButton = $this.oSysupdateBase.oInputParam.oPrevButton,
				oFile 		= $this.oSysupdateBase.oInputParam.oInputFile; // Объект файла
			if(oServer.ibUploadArray)
			{
				oServer.oUpdateHandler.date = oServer.oUploadData.date;
				oServer.oUpdateHandler.zipname = oServer.oUploadData.zipname;
				oServer.oButton = $(this); // Объект кнопки, которая была нажата
				oServer.oButton.attr('disabled','disabled');
        		oPrevButton.attr('disabled','disabled');

            	if( oServer.ibUploadArray === 1 ) // Обновляем объекты
            	{
	            	$this.oSysupdateClient.update(oFile, oServer.aClientSQL, oServer.oUpdateHandler);
            	}
            	else
            	{
            		if( oServer.ibUploadArray === 2 ) // Обновляем сервер
            		{
            			oServer.oUpdateHandler.ajaxHandler(oServer.oUpdateHandler.getUpdateData(oServer.oUploadData.aResult.server));
            		}
            	}
			}
			else
			{
				$this.oSysupdateBase.append("Нельзя приступить к обновлению. Прочитайте предыдущие записи.", "important");
			}
		},
		getUpdateHandler: function(date, zipname)
		{
			var oHandler =
			{
				parent: null,
				date: null,
				zipname: null,
				aCommitedActions: [], // Проверяем, были ли вообще обновления или нет
				bErrorAndRollback: true, // Если ajax возвращает ошибку, то пытаемся один раз выполнить откат (Если опять ошибка, то останавливаем цикл)
				bIsSuccess: false, // Успешное завершение обновление сервера (Если было, то повторно не запускается)
				ini: function(parent, date, zipname)
				{
					this.parent = parent;
					this.date = date;
					this.zipname = zipname;
					return this;
				},
				getUpdateData: function(aData)
				{
					this.parent.oSysupdateBase.append("Шаги обновления включают:","default");
	    			for( var i in aData )
	    			{
	    				var sMess = this.parent.oSysupdateBase.getActionName(i);
	    				if( sMess )
						{
							var iCount = ( i == 'sql' ) ? aData[i]['data'][0].length : aData[i].length;
							sMess += " Количество файлов: "+iCount;
							this.parent.oSysupdateBase.append(sMess,"default");
						}
	    			}

	    			this.parent.oSysupdateBase.append("Начало обновления:","default");
	    			var aaActions = [], j = 0;
	    			for( var i in aData )
	    			{
	    				var sAction = i.toString(),
	    				sName = this.parent.oSysupdateBase.getActionName(i);
						if( sName ) aaActions[j] = [sAction, sName, aData[i], this.date, this.zipname, 2];
						j++;
	    			}
	    			return aaActions;
				},
				removeStartZip: function(zipname) // Удаляем архив, распакованный в самом начале для определения действий
				{
					var $this = this,
						formdata = (window.FormData) ? new FormData() : false;
					if( formdata )
					{
						$this.parent.oSysupdateBase.loading(true);
						formdata.append('ajax', 1);
						formdata.append('operation', 5);
						formdata.append('zipname', zipname);
						$.ajax({
				            	dataType: "json",
				                url: "/sysupdate",
				                type: "POST",
				                data: formdata,
				                processData: false,
				                contentType: false,
				                success: function (data)
				                {
				                	$this.parent.oSysupdateBase.loading(false);
				                	var sColor = ( data.bResult ) ? "default" : "important";
				                	$this.parent.oSysupdateBase.append(data.sMessage, sColor);
				                	if(data.bResult)
				                	{
				                		$this.parent.oSysupdateBase.append('Ранее распакованный архив успешно удален.', sColor);
				                		$this.parent.oButton.attr('disabled', false);
				                	}
				                	else
				                	{
				                		$this.parent.oSysupdateBase.append('Не удалось удалить ранее распакованный архив.', sColor);
				                	}
				                	$this.parent.oSysupdateBase.append("Сервер ранее был успешно обновлен! Повторное обновление остановлено. ","success");
									$this.parent.oSysupdateBase.append("Если какие-то объекты не обновились, то обратитесь за консультацией в службу поддержки.","success");
									$this.parent.oSysupdateBase.saveInformation();
				                },
					            error: function (XMLHttpRequest, textStatus, errorThrown)
					            {
					            	// Фатальная ошибка, Завершение работы.
					            	$this.parent.oSysupdateBase.error(XMLHttpRequest, textStatus, errorThrown);
					            	$this.parent.oSysupdateBase.append('Не удалось удалить ранее распакованный архив.',"important");
					            	$this.parent.oSysupdateBase.append("Сервер ранее был успешно обновлен! Повторное обновление остановлено. ","important");
					            	$this.parent.oSysupdateBase.saveInformation();
								}
				            });
					}
					else
					{
						$this.parent.oSysupdateBase.errorsHandler(null, 4, 8);
					}
				},
				ajaxHandler: function(aaActions)
				{
					if( this.bIsSuccess )
					{
						if( this.parent.oSysupdateClient.bSuccessful )
						{
							this.removeStartZip(this.zipname);
						}
						else
						{
							this.parent.oSysupdateBase.append("Сервер ранее был успешно обновлен! Повторное обновление остановлено. ","success");
							this.parent.oSysupdateBase.append("Если какие-то объекты не обновились, то обратитесь за консультацией в службу поддержки.","success");
							this.parent.oSysupdateBase.saveInformation();
							this.parent.oButton.attr('disabled', false);
						}
						return false;
					}
					if( !aaActions )
					{
						this.newAjax(['zip and clear', "Обновления на сервере завершены. Запаковываем дамп. ", [], this.date, this.zipname, 4], []);
						return true; // Закончили цикл без ошибок
					}
					var aaData = this.parent.oSysupdateBase.getNewData(aaActions);
					if( aaData[0] ) this.newAjax(aaData[0], aaData[1]);
					return true;
				},
				newAjax: function(aData, aaActions)
				{
					var $this = this,
						formdata = (window.FormData) ? new FormData() : false;
					if( formdata )
					{
						$this.parent.oSysupdateBase.loading(true);
						var action_data = ( aData[0] == 'sql' ) ? JSON.stringify(aData[2]) : aData[2];
						formdata.append('ajax', 1);
						formdata.append('operation', (aData.length > 5) ? aData[5] : 2);
						formdata.append('action_name', aData[0]);
						formdata.append('action_logname', aData[1]);
						formdata.append('action_data', action_data);
						formdata.append('action_date', aData[3]);
						formdata.append('zipname', aData[4]);
						formdata.append('aCommitedActions', $this.aCommitedActions);
						$.ajax({
				            	dataType: "json",
				                url: "/sysupdate",
				                type: "POST",
				                data: formdata,
				                processData: false,
				                contentType: false,
				                success: function (data)
				                {
				                	$this.bErrorAndRollback = true;
				                	$this.parent.oSysupdateBase.loading(false);
				                	if(data.date && !$this.date) $this.date = data.date;
				                	if(data.zipname && !$this.zipname) $this.zipname = data.zipname;
				                	if( data.rollback && data.rollback == 'final' )
				                	{
				                		$this.parent.oSysupdateBase.append(data.sMessage,"success");
				                		$this.parent.oSysupdateBase.saveInformation();
				                	}
				                	else
		        					{
		        						if( !data.date ) return false;
		        						$this.aCommitedActions[$this.aCommitedActions.length] = aData[0];
		        						if( data.bResult )
			        					{
			        						var bEnd = (aData[0] == 'zip and clear');
			        						var sColor = ( bEnd ) ? "success" : "default";
			        						$this.parent.oSysupdateBase.append(data.sMessage,sColor);
			        						if( bEnd )
		        							{
		        								$this.parent.oButton.attr('disabled', false);
		        								$this.parent.oSysupdateBase.append("Обновление завершено.","success");
		        								$this.parent.oSysupdateBase.append("Если какие-то объекты не обновились, то обратитесь за консультацией в службу поддержки.","success");
		        								$this.bIsSuccess = true;
		        								$this.parent.oSysupdateBase.saveInformation();
		        							}
		        							else
		        							{
		        								$this.ajaxHandler(aaActions);
		        							}
			        					}
			        					else
			        					{
			        						$this.parent.oSysupdateBase.append(data.sMessage,"important");
			        						$this.parent.oSysupdateBase.append("Начинаем операцию по откату данных.","success");
			        						$this.newAjax(['rollback', "Начинаем операцию по откату данных", [], data.date, data.zipname, 3], []);
			        					}
			        				}
				                },
					            error: function (XMLHttpRequest, textStatus, errorThrown)
					            {
					            	// Пытаемся выполнить откат, если данная ситуация не повторяется дважды вподряд
					            	// Данный подход используется только при обновлении сервера
					            	// из-за разбиения операций на отдельные ajax-запросы
					            	if($this.bErrorAndRollback)
					            	{
					            		$this.bErrorAndRollback = false;
					            		$this.newAjax(['rollback', "Начинаем операцию по откату данных", [], $this.date, $this.zipname, 3], []);
					            	}
					            	else
					            	{
					            		// Если опять неудача, то фатальная ошибка, Завершение работы.
						            	$this.parent.oSysupdateBase.error(XMLHttpRequest, textStatus, errorThrown);
					            	}
					            	$this.parent.oSysupdateBase.saveInformation();
								}
				            });
					}
					else
			        {
			        	$this.parent.oSysupdateBase.errorsHandler(null, 4, 2);
			        }
				}
			}
			return oHandler.ini(this, date, zipname);
		}
	}
	return oSysupdateServer.ini(oSysupdateBase, oSysupdateClient);
}
